<template>
  <div class="course">
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      class="custom-slidebar"
      :size="'65px'"
      v-if="navMenu == true"
    >
      <div class="nav-nenu-box">
        <NavMenu v-if="navMenu == true" />
      </div>
    </el-drawer>
    <div
      class="nav-header"
      :class="navMenu == true ? 'nav-menu-padding' : 'nav-padding'"
    >
      <div class="nav-image">
        <router-link to="/">
          <el-image
            :src="require(`@/assets/logo-white.png`)"
            class="logo-nav vc-middle"
            :class="navMenu == true ? 'show-in-desktop' : ''"
          ></el-image>
        </router-link>
        <span
          @click="drawer = true"
          class="show-in-mobile bars"
          v-if="navMenu == true"
        >
          <i class="fas fa-bars"></i>
        </span>
      </div>
      <div class="flex-display ai-center">
        <el-form
          v-if="!user || (user && haveUserData)"
          @submit.prevent.native
          @keyup.enter.native="search"
        >
          <el-input
            placeholder="ค้นหาหลักสูตร"
            prefix-icon="el-icon-search"
            class="search-input"
            @blur="showInputSearch = false"
            :class="{ show: showInputSearch }"
            clearable
            v-model="searchText"
          ></el-input>

          <el-button
            class="font-weight-icon primary"
            v-if="!showInputSearch"
            @click="openSearchInput"
            size="mini"
            circle
            ><i class="el-icon-search"></i
          ></el-button>
        </el-form>
        <div class="mg-l-4">
          <el-dropdown
            v-if="
              user &&
                ((user.role == 0 && haveUserData) ||
                  user.role == 60 ||
                  user.role == 80)
            "
            trigger="click"
            class="cursor-pointer"
          >
            <div class="noti-icon-box">
              <el-badge
                is-dot
                class="item noti vc-middle"
                :hidden="notReadNoti == 0"
              >
                <i class="fas fa-bell text-font-24 color-white"></i>
              </el-badge>
            </div>
            <el-dropdown-menu slot="dropdown" class="menu-noti-box">
              <div class="pd-x-3 pd-y-5">
                <div class="flex-display js-between ai-center pd-b-4">
                  <h5 class="mg-y-less">
                    {{ `แจ้งเตือน (${notReadNoti}/${totalNoti})` }}
                  </h5>
                  <i class="fas fa-bell color-warning"></i>
                </div>
                <div
                  v-for="item in notiList"
                  :key="item._id"
                  class="border-b pd-b-4 pd-t-4 cursor-pointer"
                  :title="
                    !item.courseId && item.type == 1
                      ? `หลักสูตรนี้ไม่มีในระบบ`
                      : !item.userId && item.type == 2
                      ? 'นักเรียนคนนี้ไม่มีในระบบ'
                      : null
                  "
                  :class="
                    (!item.courseId && item.type == 1) ||
                    (!item.userId && item.type == 2)
                      ? 'cursor-not-allowed'
                      : 'cursor-pointer'
                  "
                >
                  <div v-if="item.type == 1">
                    <div
                      @click="
                        item.courseId
                          ? readNotification(item._id, item.courseId)
                          : null
                      "
                      class="flex-display js-between ai-center pd-b-5"
                    >
                      <div class="box-image square">
                        <avatar
                          :rounded="false"
                          :username="item.name"
                          :src="
                            `${gerUrlImageCourse(
                              item.courseId,
                              item.illustration.file
                            )}`
                          "
                          :size="30"
                        ></avatar>
                      </div>

                      <a
                        :class="
                          item.courseId
                            ? 'cursor-pointer'
                            : 'cursor-not-allowed'
                        "
                        class="color-secondary text-font-10"
                        >{{ `${item.verbs} ${item.time}` }}</a
                      >
                    </div>
                    <p class="mg-y-less text-font-10">
                      หลักสูตร {{ item.name }}
                    </p>
                  </div>
                  <div
                    v-if="item.type == 2"
                    @click="
                      item.userId
                        ? readNotification(item._id, item.userId)
                        : null
                    "
                    class="flex-display ai-start pd-b-5"
                  >
                    <div class="box-image">
                      <avatar
                        :class="{
                          facebook:
                            item.userFrom == 'faceBook' &&
                            item.profileImg == '',
                        }"
                        :rounded="false"
                        :username="`${item.nameTH}`"
                        :src="
                          item.profileImg
                            ? `${urlImage}${item.userId}/${item.profileImg}`
                            : item.userFrom == 'faceBook' &&
                              item.profileImg == ''
                            ? `https://graph.facebook.com/${item.profileFrom}/picture?type=small`
                            : `${item.profileFrom}`
                        "
                        :size="30"
                      ></avatar>
                    </div>
                    <div class="width-100 noflex">
                      <div class="text-left text-font-10 pd-l-4">
                        <p class="mg-y-less">
                          {{ `${item.nameTH} ${item.surnameTH}` }}
                          <span class="color-warning">{{ item.verbs }}</span>
                        </p>
                        <p class="mg-y-less">หลักสูตร {{ item.name }}</p>
                        <a
                          :class="
                            item.userId
                              ? 'cursor-pointer'
                              : 'cursor-not-allowed'
                          "
                          class="color-gray"
                          >{{ item.createdAt | dateTimeTh }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center pd-t-4">
                  <a
                    @click="$router.push('/notification')"
                    class="color-secondary text-font-12"
                    >ดูแจ้งเตือนทั้งหมด</a
                  >
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="user" class="menu-item-header">
          <PopupUser />
        </div>
      </div>
    </div>
    <div :class="{ 'flex-display': navMenu == true }">
      <div
        class="nav-nenu-box"
        :class="navMenu == true ? 'show-in-desktop' : ''"
      >
        <NavMenu v-if="navMenu == true" />
      </div>
      <div
        class="nav-padding"
        :class="{ 'width-100 bar-open': navMenu == true }"
      >
        <div class="nav-height">
          <div class="pd-y-3 disabled-on-print">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                v-for="(item, index) in breadCrumb"
                :key="index"
                class="message-over clamp1"
              >
                <a
                  v-if="item.path != 'back'"
                  @click="$router.push(item.path).catch(() => {})"
                  :class="{ active: index == breadCrumb.length - 1 }"
                  class="text-break-all"
                  >{{ item.name }}</a
                >
                <a
                  v-else
                  @click="$router.go(-1)"
                  :class="{ active: index == breadCrumb.length - 1 }"
                  class="text-break-all"
                  >{{ item.name }}</a
                >
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>

          <slot></slot>
        </div>
        <div class="border-t pd-y-3 disabled-on-print">
          <Footer />
        </div>
      </div>
    </div>

    <Cookie />
  </div>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import Footer from "@/components/template/Footer";
import Cookie from "@/components/template/Cookie";
import NavMenu from "@/components/template/NavMenu";
import PopupUser from "@/components/template/PopupUser";
import Avatar from "vue-avatar";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    navMenu: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    DashboardTemplate,
    Footer,
    Cookie,
    NavMenu,
    PopupUser,
    Avatar,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    topicLatest() {
      return this.$store.state.topicLatest;
    },
    haveUserData() {
      return this.$store.state.haveUserData;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  data() {
    return {
      drawer: false,
      direction: "ltr",
      breadCrumb: [],
      searchText: "",
      showInputSearch: false,
      course: "",
      subject: "",
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
      urlCouse: process.env.VUE_APP_BASE_URL_FILE_COURSE,
      totalNoti: 0,
      notReadNoti: 0,
      notiList: [],
      topicId: "",
      prefix: "",
      nameTh: "",
      lastNameTh: "",
    };
  },
  mounted() {
    if (this.$route.name !== "courseDetail") {
      this.checkAuthAccess();
    }

    if (this.user || typeof this.$route.query.userId !== "undefined") {
      this.fetchStudentsById();
    }

    if (this.token) {
      this.fetchNotification();
    }
    this.setCourse();
  },
  methods: {
    checkAuthAccess() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`check/auth`)
        .then((res) => {})
        .catch((e) => {
          this.alertCatchError(e);
          this.$store.commit("SIGNOUT");
          this.$router.push({ path: "/" }).catch(() => {
            window.location.reload();
          });
        });
    },
    gerUrlImageCourse(id, image) {
      if (this.image != "") {
        return `${this.urlCouse}${id}/${image}`;
      } else {
        return "https://1080motion.com/wp-content/uploads/2018/06/NoImageFound.jpg.png";
      }
    },
    fetchNotification() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`noti`)
        .then((res) => {
          if (res.data.success) {
            this.totalNoti = res.data.obj.length;
            let notRead = res.data.obj.filter(
              (filter) => filter.read === false
            );
            this.notReadNoti = notRead.length;
            this.notiList = res.data.obj.slice(0, 4);
          }
        })
        .catch((e) => {
          this.$store.commit("SIGNOUT");
          this.$router.push({ path: "/" }).catch(() => {
            window.location.reload();
          });
        });
    },
    readNotification(id, goto) {
      if (this.user.role == 60 || this.user.role == 80) {
        this.$router.push(`/name/list/course?userId=${goto}`).catch((e) => {});
      } else {
        this.$router.push(`/course/detail?courseId=${goto}`).catch((e) => {});
      }

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`read/${id}`).then((res) => {});
    },
    setCourse() {
      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let subject = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );

        if (subject.length > 0) {
          this.subject = subject[0];
          this.topicId = this.topicLatest
            ? `&topicId=${this.topicLatest}`
            : this.subject.topics.length > 0
            ? `&topicId=${this.subject.topics[0]._id}`
            : null;
        }
      }
    },
    setBreadCrumb() {
      this.breadCrumb = [];

      switch (this.$route.name) {
        case "courseDetail":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: null,
          });
          break;
        case "courseLearn":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: `/course/detail?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `เรียนออนไลน์`,
            path: null,
          });
          break;
        case "discussionForum":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: `/course/detail?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `เรียนออนไลน์ วิชาที่ ${this.subject.index}`,
            path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
          });
          this.breadCrumb.push({
            name: "กระดานถาม - ตอบระหว่างเรียน",
            path: null,
          });
          break;
        case "discussionForumDetail":
          if (this.user.role == 0) {
            this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
            this.breadCrumb.push({
              name: `อธิบายหลักสูตร`,
              path: `/course/detail?courseId=${this.$route.query.courseId}`,
            });
            this.breadCrumb.push({
              name: `เรียนออนไลน์ วิชาที่ ${this.subject.index}`,
              path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
            });
            this.breadCrumb.push({
              name: "กระดานถาม - ตอบระหว่างเรียน",
              path: `/discussion/forum?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}`,
            });
            this.breadCrumb.push({
              name: "กระทู้",
              path: null,
            });
          }
          break;
        case "courseTest":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: `/course/detail?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `เรียนออนไลน์`,
            path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
          });
          this.breadCrumb.push({
            name:
              this.$route.query.type == "preTest"
                ? "แบบทดสอบก่อนเรียน"
                : "แบบทดสอบหลังเรียน",
            path: null,
          });
          break;
        case "assignment":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: `/course/detail?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `เรียนออนไลน์ วิชาที่ ${this.subject.index}`,
            path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
          });
          this.breadCrumb.push({
            name: "งานที่ได้รับมอบหมาย",
            path: null,
          });
          break;
        case "createDiscussionForum":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `อธิบายหลักสูตร`,
            path: `/course/detail?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `เรียนออนไลน์ วิชาที่ ${this.subject.index}`,
            path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
          });
          this.breadCrumb.push({
            name: "กระดานถาม - ตอบระหว่างเรียน",
            path: `/discussion/forum?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}`,
          });
          this.breadCrumb.push({
            name: "ตั้งกระทู้",
            path: null,
          });
          break;
        case "feedback":
          this.breadCrumb.push({ name: "หลักสูตร", path: "/" });
          this.breadCrumb.push({
            name: `หลักสูตร ${this.course.name}`,
            path: `/course/learn?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}${this.topicId}`,
          });
          this.breadCrumb.push({
            name: " แบบประเมิน",
            path: null,
          });
          break;
        case "search":
          this.breadCrumb.push({
            name: "หน้าแรก",
            path: "/",
          });
          this.breadCrumb.push({
            name: " ค้นหา",
            path: null,
          });
          break;
        case "manageCourseCreate":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/list",
          });
          this.breadCrumb.push({
            name: " เพิ่มหลักสูตร",
            path: null,
          });
          break;
        case "manageCourseUpdate":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขหลักสูตร",
            path: null,
          });
          break;
        case "subjectCreate":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขหลักสูตร",
            path: `/manage/course/update?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: "เพิ่มวิชา",
            path: null,
          });
          break;
        case "subjectUpdate":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขหลักสูตร",
            path: `/manage/course/update?courseId=${this.$route.query.courseId}`,
          });
          this.breadCrumb.push({
            name: `แก้ไข${this.subject.name}`,
            path: null,
          });
          break;
        case "nameListProfile":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้เรียน",
            path: "/name/list",
          });
          this.breadCrumb.push({
            name:
              this.$route.query.edit == "true"
                ? "แก้ไขข้อมูลส่วนตัว"
                : "ข้อมูลส่วนตัว",
            path: null,
          });
          break;
        case "nameListActivity":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้เรียน",
            path: "/name/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขข้อมูลหลักสูตร",
            path: `/name/list/activity?userId=${this.$route.query.userId}&tab=1`,
          });
          this.breadCrumb.push({
            name:
              this.$route.query.tab == 1
                ? "หลักสูตรที่กำลังเรียน"
                : "หลักสูตรที่เรียนจบแล้ว",
            path: `/name/list/activity?userId=${this.$route.query.userId}&tab=2`,
          });
          break;
        case "nameListGrudate":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้เรียน",
            path: "/name/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขข้อมูลหลักสูตร",
            path: `/name/list/activity?userId=${this.$route.query.userId}`,
          });
          this.breadCrumb.push({
            name: "หลักสูตรที่เรียนจบแล้ว",
            path: `/name/list/activity?userId=${this.$route.query.userId}&tab=2`,
          });
          this.breadCrumb.push({
            name: `หลักสูตร ${this.course.name}`,
            path: null,
          });
          break;
        case "nameListLearning":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้เรียน",
            path: "/name/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขข้อมูลหลักสูตร",
            path: `/name/list/activity?userId=${this.$route.query.userId}`,
          });
          this.breadCrumb.push({
            name: "หลักสูตรที่กำลังเรียน",
            path: `/name/list/activity?userId=${this.$route.query.userId}&tab=1`,
          });
          this.breadCrumb.push({
            name: `หลักสูตร ${this.course.name}`,
            path: null,
          });
          break;
        case "nameListCourse":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้เรียน",
            path: "/name/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขข้อมูลหลักสูตร",
            path: null,
          });
          break;
        case "activityTotalScoreDetail":
          this.breadCrumb.push({
            name: "จัดการคะแนนหลักสูตร",
            path: "/manage/activity/score",
          });
          this.breadCrumb.push({
            name: "ภาพรวมคะแนนหลักสูตร",
            path: null,
          });
          break;
        case "manageActivitySubjectList":
          this.breadCrumb.push({
            name: "สรุปรายชื่อผู้เรียนหลักสูตร",
            path: "/summary/name/list",
          });
          this.breadCrumb.push({
            name: `${this.getPrefixLabel(this.prefix)}${this.nameTh} ${
              this.lastNameTh
            }`,
            path: null,
          });
          break;
        case "activityAssigment":
          this.breadCrumb.push({
            name: "จัดการคะแนนหลักสูตร",
            path: "/manage/activity/score",
          });
          this.breadCrumb.push({
            name: "ภาพรวมคะแนนหลักสูตร",
            path: `/activity/total/score?courseId=${this.course._id}&subjectId=${this.subject._id}`,
          });
          this.breadCrumb.push({
            name: "งานที่ได้รับมอบหมาย",
            path: null,
          });
          break;
        case "feedbackView":
          this.breadCrumb.push({
            name: "ผลการประเมินหลักสูตร",
            path: "/feedback/name/list",
          });
          this.breadCrumb.push({
            name: "แบบประเมิน",
            path: null,
          });
          this.breadCrumb.push({
            name: `${this.getPrefixLabel(this.prefix)}${this.nameTh} ${
              this.lastNameTh
            }`,
            path: null,
          });
          break;
        case "instructorCreate":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้สอน",
            path: "/instructor/list",
          });
          this.breadCrumb.push({
            name: "เพิ่มผู้สอน",
            path: null,
          });
          break;
        case "instructorUpdate":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้สอน",
            path: "/instructor/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขผู้สอน",
            path: null,
          });
          break;
        case "instructorView":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้สอน",
            path: "/instructor/list",
          });
          this.breadCrumb.push({
            name: "ข้อมูลผู้สอน",
            path: null,
          });
          break;
        case "dashboardDetail":
          this.breadCrumb.push({
            name: "Dashboard",
            path: "/dashboard",
          });
          let title =
            this.$route.query.type == 1
              ? "สรุปรายชื่อผู้สมัครหลักสูตร"
              : this.$route.query.type == 2
              ? "สรุปรายชื่อผู้เข้าร่วมหลักสูตร"
              : this.$route.query.type == 3
              ? "สรุปรายชื่อผู้กำลังเรียนหลักสูตร"
              : "สรุปรายชื่อผู้จบหลักสูตร";

          this.breadCrumb.push({
            name: title,
            path: null,
          });
          break;
        case "dashboardUserScore":
          this.breadCrumb.push({
            name: "Dashboard",
            path: "/dashboard",
          });
          this.breadCrumb.push({
            name: "สรุปรายชื่อผู้จบหลักสูตร",
            path: `/dashboard/detail/?courseId=${this.course._id}&type=4`,
          });
          this.breadCrumb.push({
            name: `${this.getPrefixLabel(this.prefix)}${this.nameTh} ${
              this.lastNameTh
            }`,
            path: null,
          });
          break;
        case "adminCreate":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้ดูแลระบบ",
            path: "/admin/list",
          });
          this.breadCrumb.push({
            name: "เพิ่มผู้ดูแลระบบ",
            path: null,
          });
          break;
        case "adminUpdate":
          this.breadCrumb.push({
            name: "จัดการรายชื่อผู้ดูแลระบบ",
            path: "/admin/list",
          });
          this.breadCrumb.push({
            name: "แก้ไขผู้ดูแลระบบ",
            path: null,
          });
          break;
        case "manageDiscussionForum":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/instructor",
          });
          this.breadCrumb.push({
            name: `วิชาที่ ${this.subject.index} ${this.subject.name}`,
            path: null,
          });
          break;
        case "manageAssignment":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/instructor",
          });
          this.breadCrumb.push({
            name: `วิชาที่ ${this.subject.index} ${this.subject.name}`,
            path: null,
          });
          break;
        case "manageAssignmentCheck":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/instructor",
          });
          this.breadCrumb.push({
            name: `วิชาที่ ${this.subject.index} ${this.subject.name}`,
            path: null,
          });
          break;
        case "viewAssigment":
          this.breadCrumb.push({
            name: "จัดการหลักสูตร",
            path: "/manage/course/instructor",
          });
          this.breadCrumb.push({
            name: `วิชาที่ ${this.subject.index} ${this.subject.name}`,
            path: `/manage/assignment/check/?courseId=${this.course._id}&subjectId=${this.subject._id}`,
          });
          this.breadCrumb.push({
            name: `${this.getPrefixLabel(this.prefix)}${this.nameTh} ${
              this.lastNameTh
            }`,
            path: null,
          });
          break;
      }
    },
    openSearchInput() {
      this.searchText = "";
      this.showInputSearch = true;

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    search() {
      this.$router.push(`/search/?query=${this.searchText}`);
    },
    fetchStudentsById() {
      let obj = {
        _id:
          typeof this.$route.query.userId !== "undefined"
            ? this.$route.query.userId
            : this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        })
        .finally(() => {
          this.setBreadCrumb();
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.font-weight-icon .el-icon-search {
  font-weight: 600 !important;
}
.nav-header {
  height: 60px;
  max-width: 100%;
  background-image: url("../assets/bg-header.png");
  background-size: cover;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 99;
}
.nav-padding {
  padding: 0 40px 0 40px;
}
@media (max-width: 991.98px) {
  .nav-padding {
    padding: 0 25px;
  }
}
@media (max-width: 767.98px) {
  .nav-padding {
    padding: 0 25px;
    max-width: 92%;
  }
}
@media (max-width: 575.98px) {
  .nav-padding {
    padding: 0 15px;
    max-width: 92%;
  }
}

.nav-menu-padding {
  padding: 0 30px 0 10px;
}
.nav-height {
  min-height: 85vh;
}
.nav-image {
  width: 80px;
  display: flex;
  align-items: center;
}
.noti-icon-box {
  width: 30px;
}

.nav-nenu-box {
  width: 71px;
  position: relative;
}
.menu-item-header {
  padding-left: 10px;
}
</style>
